import cx from "clsx";
import Image from "next/image";

interface RewardImageProps {
  isUnlocked: boolean;
  imageUrl?: string;
  unlockedImageUrl?: string;
  className?: string;
}

export const RewardImage = ({ isUnlocked, imageUrl, unlockedImageUrl, className }: RewardImageProps) => {
  const imageSrc = isUnlocked ? unlockedImageUrl : imageUrl;

  return (
    <figure
      className={cx(
        "relative flex aspect-square items-center justify-center rounded-full bg-elevation-fill-default-2 text-center",
        className,
        isUnlocked && "bg-interactive-contained-primary-idle",
      )}
    >
      {imageSrc && (
        <Image
          src={imageSrc}
          alt="Reward Image"
          width={60}
          height={60}
          className="user-select-none pointer-events-none z-10 max-h-4/6 w-auto object-contain"
          loading="eager"
        />
      )}
    </figure>
  );
};
